export const NOT_UPLOADED = 'NOT_UPLOADED';
export const UPLOADING = 'UPLOADING';
export const UPLOADED = 'UPLOADED';
